import { CreatedFrom } from 'modules/transmission/types'

export enum HotjarTrigger {
  CHAT = 'webinar_chat',
  DECLINE_WEBINAR = 'decline_webinar',
  FINISH_LIVE = 'finishLive',
  MY_WEBINARS = 'webinar_mywebinars',
  NEW_WEBINAR = 'webinar_new-webinar',
  PREVIEW = 'webinar_preview',
  REPORT = 'webinar_report',
  REVIEWS = 'webinar_reviews',
  WEBINAR_AR = 'webinar_ar',
  WEBINAR_EN = 'webinar_en',
  WEBINAR_ES = 'webinar_es',
  WEBINAR_FR = 'webinar_fr',
  WEBINAR_PT = 'webinar_pt'
}

export type FormatTriggerOptions = {
  source?: CreatedFrom,
  withLanguage?: boolean
}
